import { BRAND_MANAGE_SCOPES } from './BRAND_MANAGE_SCOPES'
import { SCA_MANAGE_SCOPES } from './SCA_MANAGE_SCOPES'

export const READ_CLIENTS = 'clients:read:all'
export const UPDATE_CLIENTS = 'clients:update:all'
export const DELETE_CLIENTS = 'clients:delete:all'
const MANAGE_SELLER_DISCOUNTS = 'discounts:manage:seller'
const MANAGE_ALL_DISCOUNTS = 'discounts:manage:all'
const MANAGE_PARTNER_WEBHOOKS = 'webhook:manage:partner'
const MANAGE_ALL_WEBHOOKS = 'webhook:manage:all'
const MANAGE_LOGISTIC = 'logistic-offers:manage:all'
const MANAGE_EXCLUSION_ZONES = 'exclusion-zones:manage:all'

export const REQUESTED_RETAIL_SCOPES = [
  READ_CLIENTS,
  UPDATE_CLIENTS,
  DELETE_CLIENTS,
  MANAGE_SELLER_DISCOUNTS,
  MANAGE_ALL_DISCOUNTS,
  MANAGE_LOGISTIC,
  MANAGE_EXCLUSION_ZONES,
  MANAGE_PARTNER_WEBHOOKS,
  MANAGE_ALL_WEBHOOKS,
  ...BRAND_MANAGE_SCOPES,
  ...SCA_MANAGE_SCOPES,
]
